import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'components/CheckboxNew';

import { VIEW_WEEKLY, VIEW_MONTHLY } from '../utils';
import { Container, Button, Text, Icon, Content, Item, CheckboxRow } from './styles';

const VIEW_OPTIONS = [
  { id: VIEW_WEEKLY, label: 'Woche' },
  { id: VIEW_MONTHLY, label: 'Monat' },
];

const ViewDropdown = ({ viewMode, showWeekends, onViewModeChange, onShowWeekendsChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentLabel = VIEW_OPTIONS.find(({ id }) => id === viewMode)?.label || 'Woche';

  const handleClick = useCallback(() => setIsOpen(($) => !$), []);
  const handleClose = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', handleClose);

      return () => document.removeEventListener('click', handleClose);
    }

    return () => null;
  }, [handleClose, isOpen]);

  const handleViewModeChange = useCallback(
    (nextViewMode) => {
      if (nextViewMode === viewMode) return;

      onViewModeChange(nextViewMode);
      handleClose();
    },
    [handleClose, onViewModeChange, viewMode]
  );

  const handleShowWeekendsChange = useCallback(
    (checked) => {
      onShowWeekendsChange(checked);
    },
    [onShowWeekendsChange]
  );

  return (
    <Container>
      <Button type="button" onClick={handleClick} isOpen={isOpen} isActive>
        <Text>{currentLabel}</Text>
        <Icon isOpen={isOpen} />
      </Button>
      <Content isOpen={isOpen}>
        {VIEW_OPTIONS.map(({ id, label }) => (
          <Item key={id} type="button" disabled={viewMode === id} onClick={() => handleViewModeChange(id)}>
            {label}
          </Item>
        ))}
        <CheckboxRow onClick={(event) => event.stopPropagation()}>
          <Checkbox
            selected={showWeekends}
            label="Wochenenden"
            onClick={handleShowWeekendsChange}
            mr={0}
            mb={0}
            borderColor="var(--color-grey6A)"
            fontSize="var(--font-size13)"
          />
        </CheckboxRow>
      </Content>
    </Container>
  );
};

ViewDropdown.propTypes = {
  viewMode: PropTypes.oneOf([VIEW_WEEKLY, VIEW_MONTHLY]).isRequired,
  showWeekends: PropTypes.bool.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  onShowWeekendsChange: PropTypes.func.isRequired,
};

export default ViewDropdown;
